import React from 'react'
import Loading from './Loading'

export default class Login extends React.Component {
  render(){
    const auth = this.props.route.auth
    const { isAuthenticated } = auth
      if(!isAuthenticated()){
        auth.login()
      }
    return(
     <Loading/>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Login.js